import { GroupState } from './types';

export const initialState: GroupState = {
  dataGroupDetail: {
    data: null,
    status: null,
  },
  rules: {
    data: null,
    status: null,
    datalist: null,
  },
  groupMessage: {
    data: null,
    status: null,
  },
  notifications: {
    data: [],
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  serviceStateReasons: {
    data: [],
    status: null,
  },
  serviceTypesAdmin: {
    data: [],
    status: null,
  },
  resolutions: {
    data: [],
    status: null,
  },
  serviceStateAlertConfig: {
    data: [],
    status: null,
  },
  notMeasuredConfig: {
    data: null,
    status: null,
  },
  notMeasuredDeviceTypes: {
    data: [],
    status: null,
  },
  notMeasuredServiceRules: {
    data: [],
    status: null,
  },
  groupServiceTypes: {
    data: [],
    status: null,
  },
  requiredFieldsConfig: {
    own: null,
    resolved: { enabled: false, fields: [] },
    catalog: [],
    status: null,
  },
  serviceReviewConfig: {
    groupId: null,
    own: null,
    resolved: { enabled: false, notifyLeadDays: 0, priority: 2 },
    status: null,
  },
  integrationConfig: {
    groupId: null, // grupo cuya config está cargada (para no enseñar la de otro ni desmontar en recargas)
    fhir: null, // config FHIR efectiva (own/sourceGroupId dentro); null = sin config en toda la cadena
    sync: { items: [], own: false, sourceGroupId: null }, // canales API/TSV por tipo de medida
    status: null,
  },
  rulesCreatedState : null,
  rulesDeletedState : null,
  groupCreatedState: null,
  groupServiceNumberCreatedState: null,
  ruleSelected: null,
  openRuleSelected: false,
  openModalNotificationShow: false,
  openModalNotificationSend: false,
  openModalNotificationEdit: false,
};
